export const pageTitle = title => {
  return (document.title = title + ' - Despacho Contable');
};
